import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalCommand.GuidedIntakePromoBanner'

export default defineMessages({
  bannerText: {
    id: `${scope}.bannerText`,
    defaultMessage: 'Build requests faster with the Guided Intake add-on',
  },
  learnMore: {
    id: `${scope}.learnMore`,
    defaultMessage: 'Learn more',
  },
})
